import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetDashboardUsersQuery } from '../../../../utils/api_service/dashboardApi';
import { useDebouncedValue } from '../../hooks';
import { ADMIN_SEARCH_DEBOUNCE_MS, ADMIN_USERS_ROWS_PER_PAGE } from '../constants';
import { mapUsersToRows } from '../functions';
import type { IUserRow } from '../interfaces';
import type { UserData } from '../../../../utils/types/DashboardTypes';

export const useUsersTab = (externalSearchTerm?: string) => {
  const history = useHistory();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const debouncedSearch = useDebouncedValue(externalSearchTerm ?? '', ADMIN_SEARCH_DEBOUNCE_MS);

  const { data, isLoading, isFetching } = useGetDashboardUsersQuery({
    search: debouncedSearch,
    page: pageNumber,
    limit: ADMIN_USERS_ROWS_PER_PAGE,
  });

  const users: UserData[] = data?.users ?? [];
  const totalRecords: number = data?.totalUsers ?? 0;
  const usersData: IUserRow[] = mapUsersToRows(users);

  const totalPages = Math.max(1, Math.ceil(totalRecords / ADMIN_USERS_ROWS_PER_PAGE));

  const handleRowClick = (_row: IUserRow) => {
    history.push('/employee-management');
  };

  const onPageChange = (page: number) => {
    setPageNumber(page);
  };

  return {
    searchTerm: externalSearchTerm,
    history,
    usersData,
    pageNumber,
    totalPages,
    loading: isLoading || isFetching,
    onPageChange,
    handleRowClick,
    totalRecords,
  };
};
